import React from 'react';
import { motion } from 'framer-motion';
export const Authority: React.FC = () => {
  return <section className="py-24 relative z-10 bg-gradient-to-b from-transparent via-neon-blue/5 to-transparent" data-id="element-15">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-17">
          <div className="w-24 h-1 bg-neon-blue mx-auto mb-8 box-glow rounded-full" data-id="element-18" />
          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-19">
            No es solo una página. Es la{' '}
            <span className="text-neon-blue text-glow" data-id="element-20">vidriera digital</span>{' '}
            de tu negocio.
          </h2>
          <p className="text-xl text-silver leading-relaxed" data-id="element-21">
            Hoy una web profesional puede marcar la diferencia entre parecer
            improvisado o transmitir confianza real. En Impulsador Digital
            creamos páginas pensadas para atraer, comunicar y convertir.
          </p>
        </motion.div>
      </div>
    </section>;
};